import { AppError, ErrorType, isCreditError } from '../../helpers/error';

export function shouldRetryFetchSSEError(error: unknown): boolean {
  if (error instanceof DOMException && error.name === 'AbortError') {
    return false;
  }

  if (error instanceof AppError) {
    return error.type !== ErrorType.HTTP_ERROR && !isCreditError(error);
  }

  return !isCreditError(error);
}
